module.exports = __webpack_public_path__ + "img/panzhixuan.0e39077c.jpg";